// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* globals wordpress_globals */

import "../styles/theme.scss";

import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

import "./modules/Disclaimer";
import "./modules/PageNavigation";
import "./modules/LanguageSwitcher";
import "./modules/LanguageDialog";
import "./modules/Animations";

import moduleDefinition, { ModuleDefinition } from "@projModules/definition";
import { fetchSVG, loadIcons } from "@projLib/SVGSprite";
import convertDataAttributesToObject from "@projLib/convertDataAttributesToObejct";

declare global {
  interface Window {
    breakpoints: {
      xs: number;
      sm: number;
      md: number;
      lg: number;
      xlg: number;
    };
    wordpress_globals: {
      google_maps_api_key: string;
    };
  }
}

/**
 * Async Modules: Modules are defined in ./modules/definitions.ts
 */
const bootstrap = {
  init() {
    this.asyncSVG.init();
    this.asyncModules.init(moduleDefinition);
    this.helpers.setWindowBreakpoints();
    // this.debug();
  },
  asyncModules: {
    init(modules: ModuleDefinition[]) {
      (modules ?? []).forEach(({ selector, moduleName, defaultArgs }) => {
        (document.querySelectorAll<HTMLElement>(selector) ?? []).forEach((el) => {
          const formattedArgs = convertDataAttributesToObject(el.dataset ?? {});
          const args = { ...defaultArgs, ...formattedArgs };
          return this.load(el, moduleName, args);
        });
      });
    },
    load: (el: HTMLElement, moduleName: string, args: Record<string, unknown>) => {
      try {
        return import(`./modules/${moduleName}`).then((mod) => {
          const Module = mod.default;
          return new Module(el, args);
        });
      } catch (error: unknown) {
        const err = error as Error;
        // eslint-disable-next-line no-console
        console.warn(err);
      }
      return false;
    },
  },
  asyncSVG: {
    init() {
      fetchSVG("./wp-content/themes/class/dist/sprite.svg")
        .catch((error: Error) => console.warn(`[fetchSVG] ${error}`));
    },
  },
  helpers: {
    setWindowBreakpoints() {
      window.breakpoints = {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xlg: 1100,
      };
    },
  },
  debug() {
    // Remove all modal elements on the page after 1 second
    (Array.from(document.querySelectorAll(".modal") ?? []))
      .forEach((modal) => setTimeout(() => modal.remove(), 1000));
  },
};

document.addEventListener("DOMContentLoaded", () => {
  bootstrap.init();
});

// SVG Sprite Loader
loadIcons();
